module.exports = __webpack_public_path__ + "media/images/bg-dark-wood-36c0befabb248cbdb27442f6a08bc8b5.jpg";